@if (!showParticipantProfile && (type === "Case" || type === "Group")) {
  <div class="parent">
    <div class="contents">
      @if (type === "Group" && isInConversation) {
        <div class="picture">
          <app-conversation-picture
            [leftConversation]="!isInConversation"
            [(pictureId)]="conversation.photoId"
            [conversationId]="conversation.id"
          ></app-conversation-picture>
        </div>
      }
      @if (type === "Group" && !isInConversation) {
        <div class="picture">
          <app-celo-avatar
            [width]="120"
            [height]="120"
            [type]="type"
            [participant]="participantToShow ? participantToShow : ''"
            [showBadge]="participantToShow?.isExternal ? false : true"
          />
        </div>
      }
      <form #form1="ngForm" class="name-field">
        <div class="celo-input-outline">
          <mat-form-field appearance="outline">
            <mat-label>{{ type }} name</mat-label>
            <input
              [disabled]="leftChat"
              required
              matInput
              [placeholder]="type + ' name'"
              name="name"
              #name="ngModel"
              [(ngModel)]="cName"
              pattern="\s*\S+.*"
              autocomplete="off"
              maxlength="200"
            />
          </mat-form-field>
        </div>
        <div class="mt-2">
          <app-celo-cancel-save-buttons
            (cancelled)="
              cName = conversation.name;
              cSubject = conversation.subject;
              form1.form.markAsPristine()
            "
            (save)="updateConvo()"
            [showNow]="form1.dirty && !saving && cName && name.valid"
          >
          </app-celo-cancel-save-buttons>
        </div>
      </form>
      @if (!leftChat && userAccount) {
        <div class="mt-4 mb-4 settings">
          <div class="section-title">{{ type }} settings</div>
          <div class="button">
            <button
              mat-button
              class="celo-tertiary-button celo-hoverable fw celo-extended-button"
              (click)="onAddParticipants()"
            >
              <mat-icon svgIcon="add-filled"></mat-icon>
              <span class="text">Add participants</span>
              <!-- <i class="material-icons-round arrow">navigate_next</i> -->
            </button>
          </div>
          @if (conversation.invitation) {
            <div class="button">
              <button
                mat-button
                class="celo-tertiary-button celo-hoverable fw celo-extended-button"
                (click)="
                  isAdmin.emit(
                    activeAdminList.indexOf(userAccount.userId) !== -1
                  );
                  openWindow.emit('invite')
                "
              >
                @if (type === "Group") {
                  <mat-icon svgIcon="ic-group"></mat-icon>
                }
                @if (type === "Case") {
                  <mat-icon svgIcon="ic-case"></mat-icon>
                }
                <span class="text"
                  >Invite to<span class="lowercase">{{ type }}</span></span
                >
              </button>
            </div>
          }
          @if (isExportCaseToPdfVisible$ | async) {
            @if (userLimits$ | async; as userLimits) {
              @if (isPdfExportable) {
                <div class="button">
                  <button
                    mat-button
                    class="celo-tertiary-button celo-hoverable fw celo-extended-button"
                    (click)="onExportToPdf(userLimits)"
                  >
                    <mat-icon svgIcon="ic-export"></mat-icon>
                    <span class="text">Export to PDF</span>
                  </button>
                </div>
              }
            }
          }
        </div>
      }
      @if (type === "Case") {
        <div class="mt-4 mb-4">
          <div class="section-title">Patient Details</div>
          <div #patientInfo class="patient-section">
            <app-edit-patient
              [patient]="patient"
              [alignment]="'vertical'"
              [canSave]="true"
              [editMode]="!leftChat"
              [optionalId]="true"
              (patientSave)="updateConvo($event)"
            >
            </app-edit-patient>
          </div>
        </div>
      }
      <div class="mt-4 mb-4">
        <div class="section-title">Participants</div>
        @if (userAccount && participants && !isConversationUpdating) {
          <mat-list>
            @if (participants.length) {
              <div>
                @for (
                  participant of participants;
                  track participant.userId;
                  let last = $last
                ) {
                  <div
                    class="celo-hoverable"
                    data-testid="conversation-participant"
                    [attr.data-user-id]="participant.userId"
                  >
                    <div
                      [ngClass]="{
                        'celo-cursor-pointer':
                          userAccount.userId !== participant.userId,
                      }"
                      class="appear_1"
                    >
                      <app-celo-participant-card
                        [isAdmin]="
                          activeAdminList.indexOf(participant.userId) !== -1
                        "
                        [profileId]="userAccount.userId"
                        [replaceMyName]="
                          userAccount.firstName +
                          ' ' +
                          userAccount.lastName +
                          ' (You)'
                        "
                        [participant]="participant"
                        [hideWorkspace]="true"
                        [hideProfession]="false"
                        [userAccount]="userAccount"
                        [conversation]="conversation"
                        [adminIds]="activeAdminList"
                        [type]="type"
                        (showProfile)="showProfile($event)"
                        (remove)="
                          remove(participant.userId, participant.firstName)
                        "
                      >
                      </app-celo-participant-card>
                    </div>
                  </div>
                }
              </div>
            }
            @if (!participants.length) {
              <div class="subtitle">No participants</div>
            }
          </mat-list>
        }
        @if (!userAccount || !participants || isConversationUpdating) {
          <div>
            <app-empty-state
              [no_message]="true"
              [isLoading]="true"
              [spinner]="true"
              [animation]="false"
              [diameter]="25"
            ></app-empty-state>
          </div>
        }
      </div>
      @if (!leftChat) {
        <div class="leave-button celo-hoverable mt-2">
          <button
            mat-button
            (click)="leaveConvo(); closeClick.emit()"
            class="fw"
          >
            <span
              >Leave <span class="lowercase">{{ type }}</span></span
            >
          </button>
        </div>
      }
    </div>
  </div>
}
@if (
  showParticipantProfile ||
  type === "Chat" ||
  type === "SelfChat" ||
  type === "UserProfile" ||
  type === "TeamChat"
) {
  <div>
    <app-profile
      [contactId]="profileInFocus"
      [userAccount]="userAccount"
      [hideSecureMessageButton]="hideSecureMessageButton"
      (userDataChanged)="userDataChanged.emit()"
    >
    </app-profile>
  </div>
}
